import api from './client'
import netapi from './netClient'
import { postParams } from '../lib/useParams'

export const getOrderList = async (prm) => {
  /*
  return api.post('order/list', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })*/
  
  return await netapi
    .post('order/list', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result
    })
}

export const addOrderHeader = async (prm) => {
  /*
  return api
    .post('order/addOrderHeader', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
    */
    return await netapi
    .post('order/addOrderHeader', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}

// export const getOrderRows = async (prm) => {
//   return api.get('order/detailRows', {
//     params: {
//       P_REQUEST: getParams({ zid_seq: prm })
//     }
//   })
// }

export const approveOrder = async (prm) => {
  /*
  return api
    .post('order/orderConfirm', postParams({ zid_seq: prm }), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    .then((result) => {
      return result.data
    })*/
    return await netapi
    .post('order/orderConfirm', postParams({ zid_seq: prm }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}

/* BEGIN ORDER CONFIRMATIONS */
export const getOrderConfirmationList = async (prm) => {
  // return api.get('order/orderConfirmationList', { params: { P_REQUEST: getParams(prm) } })
  return api.post('order/orderConfirmationList', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}

export const getOrderDetails = async (prm) => {
   /*
  return api.post('order/details', postParams({ zid_seq: prm }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
  */

  return await netapi
  .post('order/details', postParams({ zid_seq: prm }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
  .then((result) => {
    return result;
  })
}
export const getOrderDetailsPreview = async (prm) => {
  /*
  return api.post('order/detailsPreview', postParams({ webshop_number: prm }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })*/
  return netapi
  .post('order/detailsPreview', postParams({ webshop_number: prm }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
  .then((result) => {
    return result;
  })
}
export const getOrderConfirmationDetail = async (prm) => {
  // return api.get('order/confirmationDetails', {
  //   params: {
  //     P_REQUEST: getParams({ pi_message: prm }),
  //   },
  // })
  return api.post('order/confirmationDetails', postParams({ pi_message: prm }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}

export const getPendingOrders = async (prm) => {
  // return api.get('order/pendingOrderList', {
  //   params: {
  //     P_REQUEST: getParams(prm),
  //   },
  // })
  return api.post('order/pendingOrderList', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}

export const getContractListItems = async (VBeln, ZidSeq) => {
  /*return api.post('order/contractItems', postParams({ vbeln: VBeln, zid_seq: ZidSeq }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })*/
  return await netapi
  .post('order/contractItems', postParams({ vbeln: VBeln, zid_seq: ZidSeq }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
  .then((result) => {
    return result;
  })
}

export const addOrderItems = async (orderId, items) => {

  return await netapi
  .post('order/addOrderItems', postParams({ zid_seq: orderId, orderItems: items }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
  .then((result) => {
    return result.data
  })

  /*
  return api
    .post('order/addOrderItems', postParams({ zid_seq: orderId, orderItems: items }), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    .then((result) => {
      return result.data
    })
    */
}

export const addOrderItemsWithMatNumber = async (prm) => {
  /*return api
    .post('order/addOrderItemWithMaterial', postParams(prm), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    .then((result) => {
      return result.data
    })*/
    return netapi
  .post('order/addOrderItemWithMaterial', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
  .then((result) => {
    return result.data
  })
}

// export const deleteOrderItem = async (orderId, refId) => {
//   return api.post('order/deleteOrderItem', postParams({ zid_seq: orderId, refid: refId }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
//     return result.data
//   })
// }

export const updateOrderItems = async (orderId, shipTo, desc, requestedDate, items, deletedItems) => {
  /*
  return api
    .post(
      'order/updateOrderItem',
      postParams({
        zid_seq: orderId,
        ship_to: shipTo,
        header_text: desc,
        requested_shipment_date: requestedDate,
        orderItems: items,
        deletedItems: deletedItems,
      }),
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
    )
    .then((result) => {
      return result.data
    })
    */
    return netapi
    .post('order/updateOrderItem', postParams({
      zid_seq: orderId,
      ship_to: shipTo,
      header_text: desc,
      requested_shipment_date: requestedDate,
      orderItems: items,
      deletedItems: deletedItems,
    }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}

export const getColumnOrders = async (prm) => {
  // return api.get('order/getDetailColumnOrder', {
  //   params: {
  //     P_REQUEST: getParams(prm),
  //   },
  // })
  return api.post('order/getDetailColumnOrder', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}

export const addColumnOrder = async (prm) => {
  return api
    .post('order/addDetailColumnOrder', postParams(prm), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    .then((result) => {
      return result.data
    })
}

export const getCustomerList = async (prm) => {
  /*
  return api.post('order/getCustomerList', postParams({}), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })*/
  return await netapi
    .post('order/getCustomerList', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result
    })
}

export const deleteOrder = async (prm) => {
  /*
  return api
    .post('order/deleteOrder', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
    */
    return netapi
    .post('order/deleteOrder', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}

export const addOrUpdatePoNumber = async (prm) => {
  return api
    .post('order/addOrdrspHeaderExtend', postParams(prm), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    .then((result) => {
      return result.data
    })
}
export const getContMaterialRemainingQty = async (prm) => {
  /*return api
    .post('order/getContMaterialRemainingQty', postParams(prm), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    .then((result) => {
      return result.data
    })
    */
    return netapi
    .post('order/getContMaterialRemainingQty', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}

export const getPoNumber = async (prm) => {
  // return api.get('order/getOrdsrpHeaderExtend', { params: { P_REQUEST: getParams(prm) } })
  return api.post('order/getOrdsrpHeaderExtend', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}
